import { useEffect } from 'react';
import { NavigateFunction, useNavigate, useLocation } from 'react-router-dom';

export const History = {
  navigate: () => (() => undefined) as NavigateFunction,
  location: () => ({} as ReturnType<typeof useLocation>)
};

const NavigateSetter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    History.location = () => location;
  }, [location])

  useEffect(() => {
    History.navigate = () => navigate;
  }, [navigate])

  return null;
};

export default NavigateSetter;
